module.exports = __webpack_public_path__ + "img/8.f3507eab.png";